import axios from 'axios';
import { API, getSessionId } from './api';

export const sendChatMessage = async (workerId, message) => {
  const { data } = await axios.post(`${API}/chat/send`, {
    session_id: getSessionId(),
    worker_id: workerId,
    message,
  });
  return data;
};

export const getChatHistory = async (workerId) => {
  const { data } = await axios.get(`${API}/chat/history`, {
    params: { session_id: getSessionId(), worker_id: workerId },
  });
  return data.messages || [];
};

export const clearChatHistory = async (workerId) => {
  const { data } = await axios.delete(`${API}/chat/history`, {
    params: { session_id: getSessionId(), worker_id: workerId },
  });
  return data;
};

export const listHires = async () => {
  const { data } = await axios.get(`${API}/hires`, {
    params: { session_id: getSessionId() },
  });
  return data.hires || [];
};
